import type { FilterSelection } from './types'

/**
 * Toggle a value on an axis: selected if absent, deselected if present.
 *
 * Lives with the rail's data contract because every rail consumer needs the same
 * semantics — OR within an axis, AND across axes — and an axis whose last value is
 * deselected has to leave the selection entirely rather than linger as an empty list,
 * which a filtered read would send as "narrow to nothing".
 */
export function toggleFilterValue<T extends FilterSelection>(
	selection: T,
	axisCode: string,
	valueCode: string,
): FilterSelection {
	const current = selection[axisCode] ?? []
	const next = current.includes(valueCode) ? current.filter((code) => code !== valueCode) : [...current, valueCode]
	const { [axisCode]: _dropped, ...rest } = selection
	return next.length > 0 ? { ...rest, [axisCode]: next } : rest
}
